<div class="main">
  <app-header class="header" />
  <div class="content"><router-outlet /></div>
  <app-footer class="footer" />
</div>
